/**
 * Bloomreach Engagement event names.
 *
 * SDK methods (IDENTIFY, ANONYMIZE, UPDATE) are mapped to dedicated brweb SDK calls
 * in bloomreachClient.ts. All other events are dispatched via brweb.track().
 *
 * @see https://documentation.bloomreach.com/data-hub/docs/sdk-integration-for-a-new-engagement-setup
 */
export const BloomreachEventNames = {
    /** Records user consent preferences. */
    CONSENT: 'consent',
    /** Identifies the customer — calls brweb.identify({ customer_uuid }). */
    IDENTIFY: 'identify',
    /** Clears customer identity — calls brweb.anonymize() on logout. */
    ANONYMIZE: 'anonymize',
    /** Updates customer properties — calls brweb.update(). */
    UPDATE: 'update',
    /** Tracks an add-to-cart action on PDP. */
    ADD_TO_BASKET: 'cart_update',
};
